module.exports = __webpack_public_path__ + "static/media/example1_before.04747c9f.png";